export const personalInfo = {
  name: 'Griffins Siele',
  title: 'Full Stack Engineer',
  location: 'Dubai, United Arab Emirates',
  email: 'ngenogriffins@gmail.com',
  tagline:
    'Full-stack engineering for web applications, commerce platforms, and startup products — architected, built, and deployed to production.',
  roles: [
    'Software Engineer',
    'Full-Stack Developer',
    'Automation Engineer',
    'Product Builder',
  ],
  headline: 'Full Stack Engineer · React · Next.js · Node.js',
  resumeUrl: 'https://drive.google.com/file/d/1YiEL5V9N2emsWPsbQ5WubL_OipaVIUZ7/view?usp=sharing',
  social: {
    github: 'https://github.com/GriffinsSiele',
    linkedin: 'https://www.linkedin.com/in/griffins-siele-4201871b0/',
    email: 'mailto:ngenogriffins@gmail.com',
  },
  stats: [
    { value: '10+', label: 'Products Delivered' },
    { value: '3+', label: 'Years in Production' },
    { value: '3', label: 'Markets Served' },
    { value: '24/7', label: 'Remote Ready' },
  ],
  hero: {
    eyebrow: 'Full Stack Engineer',
    line1: 'The engineering layer',
    line2: 'for products that ship.',
    status: 'Available for contract engagements — React, Next.js, and full-stack delivery.',
    ctaPrimary: 'Start a project',
    ctaSecondary: 'View experience',
  },
};

export const experience = [
  {
    id: 1,
    role: 'Software Engineer',
    company: 'RiseUp Lifestyle Coaching LLC',
    period: 'Present',
    location: 'Dubai, UAE',
    type: 'current',
    highlights: [
      'Engineer digital products for corporate wellness, executive health, and performance coaching programmes',
      'Deliver automation workflows and web systems using modern JavaScript, no-code tooling, and AI integrations',
      'Support production platforms spanning burnout screening, stress management, and client-facing health tools',
    ],
    technologies: ['Bubble.io', 'n8n', 'JavaScript', 'AI Automation', 'Web Development'],
  },
  {
    id: 2,
    role: 'Web Developer Intern',
    company: 'Go2Cod',
    period: 'Oct 2024 — 2025',
    location: 'Remote',
    type: 'internship',
    highlights: [
      'Completed an intensive engineering programme with weekly production-oriented deliverables',
      'Shipped a quiz application with dynamic categories, timed sessions, scoring, and responsive layouts',
      'Built a calculator product with structured UI patterns and client-side logic in vanilla JavaScript',
    ],
    technologies: ['HTML', 'CSS', 'JavaScript', 'Responsive Design'],
  },
  {
    id: 3,
    role: 'Software Engineer',
    company: 'Freelancer.com',
    period: 'Sep 2023 — Present',
    location: 'Kenya · Remote',
    type: 'freelance',
    highlights: [
      'Deliver full-stack engineering for international clients across web applications and product builds',
      'Own delivery from requirements through deployment for HTML, JavaScript, and modern frontend stacks',
      'Partner with founders and operators across Sub-Saharan Africa on long-horizon technical initiatives',
    ],
    technologies: ['HTML5', 'JavaScript', 'Web Development', 'Software Development'],
  },
  {
    id: 4,
    role: 'Software Developer',
    company: 'BeBee',
    period: 'Nov 2022 — Present',
    location: 'Nairobi, Kenya · Remote',
    type: 'freelance',
    highlights: [
      'Provide software development, web engineering, and database design for global marketplace clients',
      'Build production applications with React.js, modern CSS, and structured JavaScript architectures',
      'Translate business requirements into maintainable technical solutions with clear delivery milestones',
    ],
    technologies: ['React.js', 'HTML5', 'CSS', 'JavaScript', 'Database Design'],
  },
];

export const education = [
  {
    id: 1,
    school: 'Middlesex University Dubai',
    degree: 'BSc Computer Science',
    period: 'Present',
    location: 'Dubai, UAE',
  },
  {
    id: 2,
    school: 'The Cooperative University of Kenya',
    degree: 'BSc Information Technology',
    period: '2019 — 2023',
    location: 'Kenya',
  },
];

export const skillCategories = [
  {
    id: 'frontend',
    label: 'Frontend',
    skills: [
      { name: 'React.js', level: 90, icon: 'https://cdn.worldvectorlogo.com/logos/react-2.svg' },
      { name: 'Next.js', level: 85, icon: 'https://cdn.worldvectorlogo.com/logos/next-js.svg' },
      { name: 'JavaScript', level: 90, icon: 'https://cdn.worldvectorlogo.com/logos/javascript-1.svg' },
      { name: 'Tailwind CSS', level: 92, icon: 'https://cdn.worldvectorlogo.com/logos/tailwindcss.svg' },
    ],
  },
  {
    id: 'backend',
    label: 'Backend',
    skills: [
      { name: 'Node.js', level: 85, icon: 'https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg' },
      { name: 'Express.js', level: 80, icon: 'https://cdn.worldvectorlogo.com/logos/express-109.svg' },
      { name: 'Ruby on Rails', level: 75, icon: 'https://cdn.worldvectorlogo.com/logos/rails.svg' },
      { name: 'PostgreSQL', level: 80, icon: 'https://cdn.worldvectorlogo.com/logos/postgresql.svg' },
      { name: 'SQLite', level: 78, icon: 'https://cdn.worldvectorlogo.com/logos/sqlite.svg' },
    ],
  },
  {
    id: 'tools',
    label: 'Platforms',
    skills: [
      { name: 'Git & GitHub', level: 88, icon: 'https://cdn.worldvectorlogo.com/logos/github-icon-1.svg' },
      { name: 'Bubble.io', level: 85, icon: null },
      { name: 'n8n', level: 82, icon: null },
      { name: 'Python', level: 70, icon: null },
    ],
  },
];

export const marqueeItems = [
  'React.js',
  'Next.js',
  'Node.js',
  'TypeScript',
  'E-commerce',
  'SaaS',
  'Startups',
  'API Design',
  'PostgreSQL',
  'Tailwind CSS',
  'Bubble.io',
  'Automation',
];

export const specializations = [
  {
    number: '01',
    title: 'Web Applications',
    description: 'Production-grade applications on React and Next.js — performant, maintainable, and built to scale.',
  },
  {
    number: '02',
    title: 'Commerce Platforms',
    description: 'End-to-end e-commerce with payments, catalog management, and operator dashboards.',
  },
  {
    number: '03',
    title: 'Startup Products',
    description: 'Focused MVPs and launch-ready systems for teams that need speed without sacrificing quality.',
  },
  {
    number: '04',
    title: 'Interface Systems',
    description: 'Cohesive UI architecture and interaction design that holds up across devices and teams.',
  },
];

export const processSteps = [
  { step: '01', label: 'Discover', detail: 'Scope objectives, users, and technical constraints' },
  { step: '02', label: 'Architect', detail: 'Define structure, flows, and delivery milestones' },
  { step: '03', label: 'Build', detail: 'Ship iteratively with review at every stage' },
  { step: '04', label: 'Deploy', detail: 'Release, hand off, and support in production' },
];

export const sectionCopy = {
  about: {
    label: 'Coverage',
    titleLine1: 'Built for every product',
    titleLine2: 'that needs to ship.',
    subtitle:
      'One engineer. Four disciplines. From architecture through deployment — without the overhead of a large agency.',
    aboutLabel: 'Profile',
    aboutText:
      'I partner with founders, operators, and distributed teams across the UAE, Africa, and beyond — delivering systems engineered for production, not prototypes.',
    cta: 'Initiate conversation',
  },
  experience: {
    label: 'Experience',
    titleLine1: 'Production roles.',
    titleLine2: 'Measurable delivery.',
    subtitle:
      'A verified track record across corporate product teams, engineering programmes, and international freelance engagements.',
    linkedinNote: 'Experience sourced from',
  },
  education: {
    label: 'Education',
    titleLine1: 'Grounded in',
    titleLine2: 'computer science.',
    subtitle:
      'Formal training in software engineering and information systems — applied directly to full-stack production work.',
  },
  skills: {
    label: 'Workspace',
    titleLine1: 'One stack.',
    titleLine2: 'Every layer.',
    subtitle:
      'Frontend, backend, and platform tooling — the complete technical surface area required to ship with confidence.',
    processLabel: 'process · pipeline',
    resumeCta: 'Download full resume',
  },
  projects: {
    label: 'Portfolio',
    titleLine1: 'Selected work',
    titleLine2: 'in production.',
    subtitle:
      'Client platforms and products currently live — with outcomes measured after launch, not before.',
    emptyState: 'No projects in this category.',
  },
  impact: {
    label: 'Outcomes',
    titleLine1: 'Results,',
    titleLine2: 'not rhetoric.',
    subtitle:
      'Post-launch metrics from shipped products. Verified delivery — no placeholder testimonials.',
    liveLabel: 'Live project',
    categoryLabel: 'Category',
    viewLive: 'View live site',
  },
  contact: {
    label: 'Contact',
    titleLine1: 'Begin your',
    titleLine2: 'next build.',
    subtitle: 'Contract and freelance engagements — Dubai-based, globally distributed.',
    formLabel: 'Message',
    formTitle: 'Send a message',
    availabilityTitle: 'Availability',
    servicesTitle: 'Engagement types',
  },
};

export const contactMethods = [
  {
    name: 'Email',
    description: 'Direct correspondence for project inquiries',
    value: personalInfo.email,
    link: personalInfo.social.email,
  },
  {
    name: 'LinkedIn',
    description: 'Professional network and background',
    value: 'Griffins Siele',
    link: personalInfo.social.linkedin,
  },
  {
    name: 'GitHub',
    description: 'Open-source work and code samples',
    value: 'GriffinsSiele',
    link: personalInfo.social.github,
  },
];

export const availability = [
  { day: 'Monday — Friday', time: '09:00 — 18:00 GST', status: 'Available', color: 'text-ant-green' },
  { day: 'Saturday', time: '10:00 — 16:00 GST', status: 'Limited', color: 'text-ant-gold' },
  { day: 'Sunday', time: '—', status: 'Unavailable', color: 'text-white/30' },
];

export const services = [
  {
    name: 'Web Applications',
    description: 'Custom platforms, dashboards, and product interfaces',
    timeframe: '2–8 weeks',
  },
  {
    name: 'Commerce Platforms',
    description: 'E-commerce systems with payments, catalog, and admin tooling',
    timeframe: '3–10 weeks',
  },
  {
    name: 'Startup Products',
    description: 'Focused MVPs and launch-ready systems for early-stage teams',
    timeframe: '4–12 weeks',
  },
  {
    name: 'Interface Systems',
    description: 'UI architecture, design systems, and interaction patterns',
    timeframe: '1–4 weeks',
  },
];

export const heroTerminal = {
  windowLabel: 'workspace',
  statusCmd: '› status',
  logs: [
    { type: 'cmd', text: '› deploy portfolio v2.0' },
    { type: 'ok', text: '✓ hero section loaded' },
    { type: 'ok', text: '✓ experience timeline ready' },
    { type: 'ok', text: '✓ skills matrix indexed' },
    { type: 'ok', text: '✓ projects gallery synced' },
    { type: 'cmd', text: '› status --check availability' },
    { type: 'ok', text: '✓ open to new contracts' },
  ],
  stack: ['React', 'Next.js', 'Node.js', 'Tailwind'],
};

export const navSections = [
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'skills', label: 'Skills' },
  { id: 'projects', label: 'Work' },
  { id: 'impact', label: 'Impact' },
  { id: 'contact', label: 'Contact' },
];